import { Pipe, PipeTransform } from '@angular/core';
import { TextService } from './text.service';

@Pipe({ name: 'screenreader' })
export class ScreenreaderPipe implements PipeTransform {
  // eslint-disable-next-line @angular-eslint/prefer-inject -- this pipe is manually constructed with `new` in several places (production code and tests), bypassing Angular DI; inject() only works within an active injection context and would throw NG0203 there
  constructor(private readonly textService: TextService) {}

  transform(value: string): string {
    return this.textService.getScreenreader(value);
  }
}
